const configLayout = {
  APPBAR: 72,
  DRAWER_WIDTH: 280,
};

export default configLayout;
